
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.01 12.973a3.44 3.44 0 00-3.313-3.29 3.394 3.394 0 00-2.22.72l-.455.355-.456-.354a3.387 3.387 0 00-2.219-.72 3.44 3.44 0 00-3.313 3.289 3.439 3.439 0 001.37 2.885l.297.223v2.022a4.3 4.3 0 00.296 1.572c.763-.255 2.128-.59 4.025-.59 1.898 0 3.262.335 4.025.59a4.298 4.298 0 00.297-1.572V16.08l.296-.223a3.439 3.439 0 001.37-2.885zm-9.382-.602h1.67v1.484h-1.67v-1.484zm2.56 4.823h-1.67v-1.485h1.67v1.485zm3.338 0h-1.67v-1.485h1.67v1.485zm.89-3.339h-1.669v-1.484h1.67v1.484zM10.017 20.568c-1.449 0-2.536.217-3.22.412a4.311 4.311 0 006.44 0c-.682-.194-1.77-.412-3.22-.412z","fill":"#E7E5EC"}}),_c('path',{attrs:{"d":"M19.985 15.492l-.61-6.542a9.377 9.377 0 00-3.029-6.074 9.378 9.378 0 00-6.329-2.45c-2.346 0-4.594.87-6.328 2.45A9.378 9.378 0 00.66 8.95l-.61 6.542a9.36 9.36 0 002.41 7.202 9.36 9.36 0 006.947 3.069h1.221a9.36 9.36 0 006.947-3.069 9.359 9.359 0 002.41-7.202zm-4.161 1.312v1.299a5.813 5.813 0 01-5.807 5.806 5.813 5.813 0 01-5.806-5.806v-1.299a4.924 4.924 0 01-1.665-3.89A4.93 4.93 0 017.294 8.2c.961-.031 1.91.22 2.723.717a4.935 4.935 0 012.724-.717 4.93 4.93 0 014.748 4.714 4.924 4.924 0 01-1.665 3.89z","fill":"#E7E5EC"}})])
          )
        }
      }
    